import { useEffect } from 'react';

import PropTypes from 'prop-types';

import _isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';

import { IDENTIFY_USER_DELAY, FRONT_CHAT_ID } from './FrontChat.constants';
import { frontChatIdentify, frontChatAvailable, createFrontChatScript } from './FrontChat.utils';
import { selectBusiness } from '../../../../selectors';
import { selectUser } from '../../../../selectors/user';

const propTypes = {
  chatId: PropTypes.string,
  nonce: PropTypes.string,
  autoIdentify: PropTypes.bool,
};

const defaultProps = {
  chatId: FRONT_CHAT_ID,
  nonce: null,
  autoIdentify: true,
};

/**
 * Front Chat widget component
 * Integrates Front Chat widget into the application
 * Based on Front Chat documentation: https://help.front.com/en/articles/2049
 */
export default function FrontChat({ chatId, nonce, autoIdentify }) {
  const user = useSelector(selectUser) || {};
  const business = useSelector(selectBusiness) || {};

  const { id: userId } = user;
  const { id: businessId } = business;

  function identifyUser() {
    if (frontChatAvailable() && !_isEmpty(user) && autoIdentify) {
      frontChatIdentify(user, business);
    }
  }

  useEffect(() => {
    if (!chatId) {
      // eslint-disable-next-line no-console
      console.warn('FrontChat: chatId is required but not provided');
      return;
    }

    createFrontChatScript({
      chatId,
      nonce,
      onLoad: () => {
        setTimeout(() => {
          identifyUser();
        }, IDENTIFY_USER_DELAY);
      },
    });
  }, []);

  useEffect(() => {
    if (frontChatAvailable() && autoIdentify) {
      identifyUser();
    }
  }, [userId, businessId]);

  return null;
}

FrontChat.propTypes = propTypes;
FrontChat.defaultProps = defaultProps;
